import { claimSecondParent } from '../api/second-parents.js';
import { WelcomeRoute, type Claim } from './welcome-route.js';

/**
 * /join?token=… — where a second parent's Sign up lands (canvas row D,
 * approved 17 October). Stage C's landing, joining the family the first parent
 * invited them to; then Account, where the gate shows their profile form
 * first.
 */

const join: Claim = async (getToken, hash) => {
  await claimSecondParent(getToken, hash);
  return '/account';
};

export function JoinRoute() {
  return <WelcomeRoute claim={join} />;
}
